import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import FormField from "ds/components/Form/Field";

type FormFieldTimestampProps = {
  timestamp: number;
  label: string;
  noMargin?: boolean;
};

const FormFieldTimestamp = ({ timestamp, label, noMargin }: FormFieldTimestampProps) => {
  return (
    <FormField label={label} noMargin={noMargin}>
      <Box align="center">
        <Timestamp timestamp={timestamp} />
      </Box>
    </FormField>
  );
};

export default FormFieldTimestamp;
